import { mapActions, mapGetters } from "vuex";

export const ligneRobComMixin = {
  computed: {
    ...mapGetters({
      ligneRobComsIsLoading: "ligneRobCom/list/isLoading",
      ligneRobComs: "ligneRobCom/list/items",
    }),
  },
  methods: {
    ...mapActions({
      getligneRobComs: "ligneRobCom/list/getItems",
    }),
  },
};
